import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as FeatureFlagActions from './featureFlags.actions';
import { Store } from '@ngrx/store';
import { catchError, concatMap, filter, map, withLatestFrom } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { globalFailure } from './../../../app/@store/common.actions';
import * as _ from 'lodash';
import { PublicPartnerApiService } from './../../../app/@shared/services/publicpartnerapi.service';
import { getAccountListConfig } from '../account/account.selectors';
import { FeatureFlagsTemplate } from './../../../app/@shared/models/featureFlags';
import { getDefault } from './featureFlags.selectors';
import { loginSuccess } from '../auth/auth.actions';

@Injectable()
export class FeatureFlagEffects {
  constructor(private readonly actions$: Actions, private readonly store: Store, private readonly apiPublic: PublicPartnerApiService) { }

  loadFeatureFlags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FeatureFlagActions.loadFeatureFlags, loginSuccess, FeatureFlagActions.patchFeatureFlagsSuccess),
      withLatestFrom(this.store.select(getAccountListConfig)),
      concatMap(
        action =>
          this.apiPublic.get<{ templates_feature_flags: FeatureFlagsTemplate[] }>('/partners/##CURRENT_PARTNER_UUID##/templates_feature_flags', {}).pipe(
            map((result) => {
              return FeatureFlagActions.loadFeatureFlagsSuccess({
                featureFlags: result.templates_feature_flags
              });
            }),
            catchError(error => of(FeatureFlagActions.loadFeatureFlagsFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );

  patchFeatureFlags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FeatureFlagActions.patchFeatureFlags),
      concatMap(
        action =>
          this.apiPublic.patch<void>('/partners/##CURRENT_PARTNER_UUID##/templates_feature_flags/' + action.feature_flag_template_uuid, { values: action.data }).pipe(
            map((result) => {
              return FeatureFlagActions.patchFeatureFlagsSuccess({
                feature_flag_template_uuid: action.feature_flag_template_uuid
              });
            }),
            catchError(error => of(FeatureFlagActions.patchFeatureFlagsFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );

  loadDefaultPriceTemplate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FeatureFlagActions.loadFeatureFlagsSuccess),
      withLatestFrom(this.store.select(getDefault)),
      filter(([featureFlags, defaultFFTemplate]) => defaultFFTemplate !== undefined),
      concatMap(([featureFlags, defaultFFTemplate]) => {
        return this.apiPublic.get<{ template_feature_flags: FeatureFlagsTemplate }>('/partners/##CURRENT_PARTNER_UUID##/templates_feature_flags/' + defaultFFTemplate!.object_uuid).pipe(
          map((result) => {
            return FeatureFlagActions.loadDefaultFeatureFlagsSuccess({
              featureFlags: result.template_feature_flags
            });
          }),
          catchError(error => of(FeatureFlagActions.loadDefaultFeatureFlagsFailure({ error }), globalFailure({ error })))
        );
      })
    )
  );
}
